/* eslint-disable yoda */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@ps-design-system/components/Button';
import { useToast } from '@ps-design-system/components/Toast';
import { Divider } from '@ps-design-system/components/Divider';

import { useUploaderPageData } from '../../context/UploaderPageContext';
import { useUploaderActions } from '../../hooks/useUploaderActions';
import useUploaderStore from '../../store/useUploaderStore';
import { isMinimumPhotoRequirementMet } from '../../utils/media.utils';
import { TOAST_DURATION } from '../../constants/actions.consts';

const UploaderBottomNavigationWeb = () => {
  const { isListing, spaceId, router } = useUploaderPageData();
  const media = useUploaderStore((state) => state.media);
  const { toast } = useToast();
  const { handleSave } = useUploaderActions();

  const handleBackClick = () => {
    window.location.href = `/your-space/${spaceId}`;
  };

  const handleSaveClick = () => {
    if (isMinimumPhotoRequirementMet(media)) {
      handleSave();
      if (!isListing) {
        router.push(`/your-space/${spaceId}/availability`);
      }
    } else {
      toast({
        title: '',
        description: <FormattedMessage id="uploader.toast.error_minimum" defaultMessage="5 photos are required for your listing"/>,
        variant: 'destructive',
        duration: TOAST_DURATION
      });
    }
  };

  return (
    <div className="uploader-bottom-navigation">
      <Divider spacing={24} />
      <div className="bottom-navigation-container">
        {
          !isListing && (
            <div>
              <Button appearance="white" variant="outline-1" showSpinner={false} onClick={handleBackClick} attributes={{ 'data-testing-id': 'upload-page-back' }}>
                <FormattedMessage id="uploader.page.back" defaultMessage="Back"/>
              </Button>
            </div>
          )
        }

        <div className="next-button">
          {isListing
            ? (
              <Button appearance="purple" showSpinner={false} onClick={handleSaveClick} attributes={{ 'data-testing-id': 'upload-save-footer' }}>
                <FormattedMessage id="uploader.page.save" defaultMessage="Save"/>
              </Button>
            )
            : (
              <Button appearance="purple" showSpinner={false} onClick={handleSaveClick} attributes={{ 'data-testing-id': 'upload-next-footer' }}>
                <FormattedMessage id="uploader.page.next" defaultMessage="Next"/>
              </Button>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default UploaderBottomNavigationWeb;
